<template>
  <v-overlay :value="globalLoader.show" :z-index="100">
    <v-layout row wrap>
      <v-flex xs12>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-flex>
      <v-flex xs12>
        <span>{{ globalLoader.message }}</span>
      </v-flex>
    </v-layout>
  </v-overlay>
</template>

<script>
export default {
  computed: {
    globalLoader: {
      get() {
        return this.$store.getters.globalLoader;
      },
      set(value) {
        this.$store.commit("showGlobalLoader", {
          value: value,
          message: ""
        });
      }
    }
  }
};
</script>
